import { SliderDropdown as SliderDropdownType, SliderDropdownGroup as SliderDropdownGroupType } from '../../../../../types/Survey/Element'
import {
  SliderDropdownGroup as SliderDropdownGroupAnswerType,
  SliderDropdown as SliderDropdownAnswerType,
} from '../../../../../types/Survey/Answer/Element'
import { Props } from './types'
import Core from './Core'
import ChartWrapper from './ChartWrapper/ChartWrapper'
import props from '../../../../../redux/props'
import { useSelector } from 'react-redux'
import Pie from '../../../../UI/Chart/Pie/Pie'
import SliderDropdown from './SliderDropdown'

const SliderDropdownGroup: React.FC<Props<SliderDropdownGroupType, SliderDropdownGroupAnswerType>> = ({ element, answerElement, updateElement }) => {
  const t = useSelector((s) => s[props.TRANSLATION])

  const getTotal = (excludeUUID?: string) =>
    answerElement.sliderDropdowns.reduce((acc, s) => {
      if ((!!excludeUUID && s.uuid !== excludeUUID) || !excludeUUID) {
        return acc + s.value
      }
      return acc
    }, 0)

  const updateSlider = (uuid: string) => (updatedAnswer: SliderDropdownAnswerType) => {
    if (updatedAnswer.value + getTotal(uuid) <= 100) {
      const updatedSliders = answerElement.sliderDropdowns.map((s) => (s.uuid === uuid ? updatedAnswer : s))
      updateElement({ ...answerElement, sliderDropdowns: updatedSliders })
    }
  }

  return (
    <div>
      <Core element={element} answerElement={answerElement} />
      <div className="flex flex-col gap-5 mt-6">
        {element.sliderDropdowns.map((s: SliderDropdownType, index: number) => (
          <SliderDropdown small key={s.uuid} element={s} answerElement={answerElement.sliderDropdowns[index]} updateElement={updateSlider(s.uuid)} />
        ))}
        {element.sliderDropdowns.length > 2 && (
          <div className="font-bold text-lg text-center mt-3">{`${getTotal()}${t.survey.answer.sliderGroup.totalSuffix}`}</div>
        )}
      </div>
      <ChartWrapper>
        <Pie
          items={element.sliderDropdowns.map((s: SliderDropdownType, index: number) => ({
            label: s.title,
            value: answerElement.sliderDropdowns[index].value,
          }))}
        />
      </ChartWrapper>
    </div>
  )
}

export default SliderDropdownGroup
